import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants';
import { environment } from '../../environments/environment';
import { HerramientaDto } from '../dto/justino/herramienta.dto';


@Injectable({
  providedIn: 'root'
})
export class HerramientaService {

  private apiUrl = `${environment.justinoApiUrl}/api/tools/`;
  
  constructor(private http: HttpClient) {}

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? '';
    return { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  getHerramientas(): Observable<HerramientaDto[]> {
    return this.http.get<HerramientaDto[]>(this.apiUrl, { headers: this.getHeaders() });
  }

  getHerramientaById(id: string): Observable<HerramientaDto> {
    return this.http.get<HerramientaDto>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }
}
